<template>
  <div>
    <component :is="evaluationFormComponentName"
               v-model="proposal"
               @close-modal="saveEvaluation"/>
  </div>
</template>

<script>
  import AdditionalSampleEvaluationRadiationForm
    from '@/components/evaluation/radiation/AdditionalSampleEvaluationRadiationForm';
  import AdditionalSampleEvaluationSafetyForm
    from '@/components/evaluation/safety/AdditionalSampleEvaluationSafetyForm';

  export default {
    name: 'AdditionalSampleEvaluationModal',
    components: {
      AdditionalSampleEvaluationRadiationForm,
      AdditionalSampleEvaluationSafetyForm,
    },
    props: {
      evaluationType: {
        type: String,
        required: true,
      },
      value: {
        type: Object,
        required: true,
      },
    },
    data() {
      return { proposal: this.value };
    },
    computed: {
      evaluationFormComponentName() {
        return this.evaluationType === 'safety'
          ? 'AdditionalSampleEvaluationSafetyForm'
          : 'AdditionalSampleEvaluationRadiationForm';
      },
    },
    watch: {
      async value() {
        this.proposal = JSON.parse(JSON.stringify(this.value));
      },
    },
    methods: {
      async saveEvaluation() {
        const evaluationKey = `${this.evaluationType}_evaluation`;
        const evaluation = this.proposal.additional_sample_declaration[evaluationKey];
        try {
          const proposalId = this.getId(this.proposal);
          const response = await this.axios.post(
            `/documents/${proposalId}/additional-samples/${this.evaluationType}/synchrotron`,
            evaluation,
          );
          if (response.status === 200) {
            this.$set(evaluation, 'states', response.data.additional_sample_declaration[evaluationKey].states);
            this.$emit('input', this.proposal);
            this.$notify({ type: 'success', title: 'Saved successfully!' });
            this.closeModalEmit();
          } else {
            this.$notify({ type: 'error', title: 'Error during saving' });
          }
        } catch {
          this.$notify({ type: 'error', title: 'Communication error' });
        }
      },
    },
  };
</script>

<style scoped>
</style>
